/*********************************************************************************************
* Video play / pause
    *
*/
document.addEventListener('DOMContentLoaded', () => {
    // Fonction pour gérer l'interaction vidéo/bouton
    const handleVideoInteraction = (section) => {
        const video = section.querySelector('video');
        const playButton = section.querySelector('.play-btn');

        if (video && playButton) {
            // Ajouter un événement sur le bouton
            playButton.addEventListener('click', () => {
                if (video.paused) {
                    video.muted = false; // Désactiver le mode muet
                    video.play();        // Démarrer la vidéo
                    playButton.style.display = 'none'; // Masquer le bouton
                }
            });

            // Ajouter un événement sur la vidéo pour la pause
            video.addEventListener('click', () => {
                if (!video.paused) {
                    video.pause();       // Mettre en pause la vidéo
                    playButton.style.display = 'block'; // Afficher le bouton
                }
            });
        }
    };

    // Récupérer toutes les sections pertinentes
    const sections = document.querySelectorAll('.mm-faq[data-section-faq-id]');
    const sectionsConseils = document.querySelectorAll('.mm-conseil-utilisation[data-section-conseil-utilisation-id]');
    sections.forEach(handleVideoInteraction);
    sectionsConseils.forEach(handleVideoInteraction);
});
